import { render, staticRenderFns } from "./merchantOrder.vue?vue&type=template&id=64b38cdc&scoped=true"
import script from "./merchantOrder.vue?vue&type=script&lang=js"
export * from "./merchantOrder.vue?vue&type=script&lang=js"
import style0 from "./merchantOrder.vue?vue&type=style&index=0&id=64b38cdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b38cdc",
  null
  
)

export default component.exports